import React, { FC, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { OrderPartsHelpArrowlength } from '@component/OrderPartsHelp';
import { OrderPartsImg } from '@app/react/uikit';
import { PartsProduct } from '@app/react/const/type';
import { useMediaDesktop } from '@app/react/common/useMedia';
import { ToggleButton } from './ToggleButton';
import { OrderSelectBaseLayout } from './OrderSelectBaseLayout';

const partsNameProps = '矢尺(矢の長さ)';

export interface OrderYashakuSelectComponentProps {
    className?: string;
    adjust: boolean | null;
    onAdjust: (adjust: boolean | null) => void;
    arrowlengths: Array<PartsProduct>;
    arrowlength: PartsProduct | null;
    onArrowlength: (arrowlength: PartsProduct) => void;
    isHelpOpen: boolean;
    handleHelpOpen: () => void;
    handleHelpClose: () => void;
}

export const OrderYashakuSelectComponent: FC<OrderYashakuSelectComponentProps> = (
    props,
) => {
    const {
        className,
        adjust,
        onAdjust,
        arrowlengths,
        arrowlength,
        onArrowlength,
        isHelpOpen,
        handleHelpOpen,
        handleHelpClose,
    } = props;

    const isDesktop = useMediaDesktop();

    const arrowlengthIndex = useMemo(() => {
        const predicate = (value: PartsProduct) => value.id === arrowlength?.id;
        const ret = arrowlengths.findIndex(predicate);
        return ret;
    }, [arrowlength, arrowlengths]);

    const handleArrowlength = useCallback(
        (event: React.ChangeEvent<HTMLSelectElement>) => {
            const index = parseInt(event.target.value, 10);
            onArrowlength(arrowlengths[index]);
        },
        [arrowlengths, onArrowlength],
    );

    const rootClassName = classNames('order-yashaku-select', className);
    const yashakuClassName = classNames({
        disabled: !adjust,
    });

    const groupOptions = [
        {
            displayName: 'する',
            value: true,
        },
        {
            displayName: 'しない',
            value: false,
        },
    ];

    return (
        <>
            <OrderSelectBaseLayout
                classNames={{ root: rootClassName }}
                header={isDesktop && (
                    <OrderPartsImg
                        partsName={partsNameProps}
                        showHelpBtn
                        onHelpClick={handleHelpOpen}
                    />
                )}
                body={(
                    <div className="design-container">
                        <p className={classNames('section-header', { hidden: isDesktop })}>
                            矢尺(矢の長さ)
                        </p>

                        <span className="caption">
                            ※長くお作りした矢は、後に短く調整することが可能ですので、
                            長めに製作することをおすすめしております。
                        </span>

                        <table className="order-yashaku-select-table">
                            <tr>
                                <th className="table-col1">
                                    <span>1. 矢の調整</span>
                                </th>
                                <th className="table-col2">
                                    <ToggleButton<boolean | null>
                                        value={adjust}
                                        onChange={onAdjust}
                                        groupOptions={groupOptions}
                                    />
                                </th>
                            </tr>
                            <tr className={yashakuClassName}>
                                <th className="table-col1">
                                    <span className="table-col1-label">
                                        2. 矢尺
                                    </span>
                                </th>
                                <th className="table-col2">
                                    <select
                                        className="table-col2-value"
                                        onChange={handleArrowlength}
                                        value={arrowlengthIndex}
                                        disabled={!adjust}
                                    >
                                        <option value="-1">選択してください</option>
                                        {arrowlengths.map((row, index) => (
                                            <option key={row.id} value={index}>
                                                {row.name}
                                            </option>
                                        ))}
                                    </select>
                                </th>
                            </tr>
                        </table>
                    </div>
                )}
            />
            <OrderPartsHelpArrowlength
                isOpen={isHelpOpen}
                handleOpen={handleHelpOpen}
                handleClose={handleHelpClose}
            />
        </>
    );
};
